import { MutationTree } from 'vuex';
import { PurchaseOrder } from '@/interface/store/purchaseOrder';
import { initialState } from '@/store/modules/purchaseOrder/index';

export const mutations: MutationTree<PurchaseOrder> = {
  SET_PO_DETAILS(state, payload) {
    state.poData = payload;
  },
  SET_PO_ATTACHMENTS(state, payload) {
    state.poAttachments = payload.data;
  },
  INIT_PO_DETAILS(state) {
    state = initialState();
  },
};
